// pwa.js — Service Worker, Verbindungshinweis und Push-Abo der neuen Oberfläche.
// Der Service Worker wird nur angemeldet, wenn die Hülle ein Manifest verlinkt (alle Hüllen über {{PWA}}).
import { t } from './i18n.js';
import { snackbar } from '../ui/components/snackbar.js';

export const RELOAD_FLAG = 'vc-sw-reloaded';

/** Ist die neue Oberfläche die installierbare App (Manifest verlinkt)? */
export const isPwaShell = () => typeof document !== 'undefined' && !!document.querySelector('link[rel="manifest"]');

/**
 * Antwort auf eine Nachricht des Service Workers. Bei 'vc-ui-switched' (alte ↔ neue Oberfläche) wird
 * genau einmal je Sitzung neu geladen — ein normaler Versionssprung lädt nicht neu (niemand verliert Eingaben).
 */
export function onSwMessage(data, storage, reload) {
  if (!data || data.type !== 'vc-ui-switched') return false;
  try { if (storage.getItem(RELOAD_FLAG)) return false; storage.setItem(RELOAD_FLAG, '1'); } catch { return false; }
  reload();
  return true;
}

export function registerServiceWorker() {
  if (!isPwaShell() || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.addEventListener('message', (e) => onSwMessage(e.data, sessionStorage, () => location.reload()));
  const go = () => navigator.serviceWorker.register('/sw.js').catch(() => {});
  if (document.readyState === 'complete') go(); else addEventListener('load', go, { once: true });
}

/** Snackbar bei Verbindungsverlust (bleibt stehen) und bei Rückkehr (verschwindet von selbst). */
export function installNetworkStatus(win = window) {
  if (!('onLine' in win.navigator)) return;
  let wasOffline = false;
  const offline = () => { wasOffline = true; snackbar({ text: t('ui.offline'), key: 'net-state', duration: Infinity }); };
  const online = () => { if (!wasOffline) return; wasOffline = false; snackbar({ text: t('ui.online'), key: 'net-state', duration: 2500 }); };
  if (!win.navigator.onLine) offline();
  win.addEventListener('offline', offline);
  win.addEventListener('online', online);
}

// ---------- Push ----------
export function urlBase64ToUint8Array(s) {
  const b64 = (s + '='.repeat((4 - (s.length % 4)) % 4)).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(b64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

/** 'unsupported' | 'denied' | 'on' | 'off' — ohne den Nutzer zu fragen. */
export async function pushState() {
  if (!isPwaShell() || !('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) return 'unsupported';
  if (Notification.permission === 'denied') return 'denied';
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return 'unsupported';
  return (await reg.pushManager.getSubscription()) ? 'on' : 'off';
}

/** Fragt (nur hier, auf ausdrücklichen Wunsch) die Erlaubnis ab und meldet das Abo an. */
export async function enablePush(api) {
  const k = await api.get('/api/push/vapid-key');
  const key = k.ok && k.data && k.data.key;
  if (!key) return 'unsupported';
  if ((await Notification.requestPermission()) !== 'granted') return 'denied';
  const reg = await navigator.serviceWorker.ready;
  const sub = (await reg.pushManager.getSubscription()) || await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(key) });
  const r = await api.post('/api/push/subscribe', sub.toJSON());
  return r.ok ? 'on' : 'error';
}

export async function disablePush(api) {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && await reg.pushManager.getSubscription();
  if (sub) await sub.unsubscribe().catch(() => {});
  const r = await api.del('/api/push/subscribe');
  return r.ok ? 'off' : 'error';
}
